export const UPLOAD_IMAGE_SIZE = 6144 //image size in KB